import type { PageProps } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import MainTitle from '@components/MainTitle';

import AppLayout from '@layouts/AppLayout';
import { MainContainer } from '@layouts/DrilldownStyle';

import Main from '@views/Records/Insurance/Main';

const messages = defineMessages({
  title: {
    id: 'insurancePage.title',
    defaultMessage: 'Insurance',
  },
});

export default function InsurancePage({ params }: PageProps) {
  const { formatMessage } = useIntl();
  return (
    <AppLayout friendlyName={formatMessage(messages.title)} showHeader>
      <MainContainer maxWidth="600px">
        <MainTitle title={formatMessage(messages.title)} />
        <Main {...params} />
      </MainContainer>
    </AppLayout>
  );
}
